import React, { useEffect } from 'react';
import { FormikProps } from 'formik';

import { useCityContext } from 'app/shared/context/City';

import { FormWithCitySelector } from './FormWithCitySelector';
import { FormWithoutCitySelector } from './FormWithoutCitySelector';
import { OnNewsletterSuccess, Success } from './Success';

export const Content: React.FC<
  React.PropsWithChildren<{
    isSuccess: boolean;
    formikProps: FormikProps<any>;
    formContext: string;
    withCitySelector: boolean;
    useTwoColumnLayout?: boolean;
    ctaText?: string;
    fullWidthCta?: boolean;
    onSuccess?: OnNewsletterSuccess;
  }>
> = ({
  isSuccess,
  formikProps,
  formContext,
  withCitySelector,
  useTwoColumnLayout,
  ctaText,
  fullWidthCta,
  onSuccess,
}) => {
  const { lastViewedCity, closestCities } = useCityContext();
  const defaultCity = lastViewedCity || closestCities?.[0];
  const { setFieldValue } = formikProps;

  useEffect(() => {
    if (defaultCity) {
      setFieldValue('city', defaultCity);
    }
  }, [lastViewedCity, closestCities]);

  if (isSuccess) {
    const { email, city } = formikProps.values;

    return (
      <Success
        userEmail={email}
        city={city || closestCities?.[0]}
        formContext={formContext}
        onLoad={onSuccess}
      />
    );
  }

  if (withCitySelector) {
    return (
      <FormWithCitySelector
        formikProps={formikProps}
        useTwoColumnLayout={useTwoColumnLayout}
        fullWidthCta={useTwoColumnLayout}
        ctaText={ctaText}
        defaultCity={defaultCity}
      />
    );
  }

  return (
    <FormWithoutCitySelector
      formikProps={formikProps}
      fullWidthCta={fullWidthCta}
      ctaText={ctaText}
    />
  );
};
